module.exports = __webpack_public_path__ + "static/media/README.9d1b645f.md";